export default __webpack_public_path__ + "static/media/arrow.eb06e7f4.svg";